module.exports = __webpack_public_path__ + "static/media/Taxi.47e3765b.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/logos/Taxi.png
// module id = 207
// module chunks = 0